import { connect } from 'react-redux';
import ManageAddPoc from './manageAddPoc';
import { bindActionCreators } from 'redux';
import { addPoc, getPocById, editPoc } from 'services/redux/brandActivtion/manageAddEditPoc/action'


const mapStateToProps = state => ({
    pocDetails: state.managePocReducer.pocDetails,
    pocById: state.managePocReducer.pocById
});

const mapDispatchToProps = dispatch => bindActionCreators({
    addPoc,
    getPocById,
    editPoc
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ManageAddPoc);
